import styled from '@emotion/styled';
import Button from '@mui/material/Button';

const TabButton = styled(Button)`
  height: 40px !important;
  border-radius: 28px;
  text-transform: none;
  margin: 16px 0;
  min-width: 200px;
  background: ${props => (props.className === 'active' ? '#231727' : '#FDF3DE')};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  color: ${props => (props.className === 'active' ? '#FDF3DE' : '#231727')};
  :hover {
    cursor: pointer;
    background: rgba(35, 23, 39, 0.2);
    box-shadow: none;
  }
`;

export default TabButton;
